var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "quicktrial__wrapper" }, [
    _c(
      "article",
      { staticClass: "quicktrial__inner onboarding-quicktrial__informations" },
      [
        _c(
          "header",
          { staticClass: "onboarding-quicktrial__informations-header" },
          [
            _c("SaasIcon", {
              staticClass: "onboarding-quicktrial__informations-header-logo",
              attrs: {
                icon: "svgLogoSellsyText",
                width: _vm.isDesktop ? 118 : 168,
                height: _vm.isDesktop ? 28 : 40
              }
            }),
            _vm._v(" "),
            _c("CompassBackForwardButton", {
              attrs: {
                label: _vm.$t.__("common.labels.back_to_sellsy_website"),
                link: "https://go.sellsy.com",
                type: "secondary",
                size: "small",
                back: ""
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm._t("banner")
      ],
      2
    ),
    _vm._v(" "),
    _c("article", { staticClass: "quicktrial__inner" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }